export default {
  examDetail_total: 'Total score:',
  examDetail_pass_score: 'Qualified:',
  examDetail_exam_time: 'Exam time',
  examDetail_score: 'Grade',
  examDetail_pass_or_not: "Pass/Failed",
  examDetail_not_yet: 'N/A',
  examDetail_in_marking: 'Marking',
  examDetail_passed: 'Approved',
  examDetail_failed: 'Fail',
  examDetail_submit_marking_tip: 'Handed in successfully. The teacher is marking the paper',
  examDetail_passed_exam_tip: 'Congratulations! You have passed the exam',
  examDetail_failed_tip: 'Unfortunately, you failed. Keep moving~',
  examDetail_test_again: 'Try Again',
  examDetail_check_score: "Once the marking is complete, you can access the exam again to view your results",
  examDetail_check_wrong: 'View incorrect questions',
  examDetail_check_certificate: 'View certificate',
  examDetail_my_answers: "My archive:",
  examDetail_no_answer: 'Left',
  examDetail_correct_answer: 'Correct answer:',
  examDetail_camera_invigilate: 'Please enable the camera for proctoring',
  examDetail_camera_unusual: 'Camera error. Failed to access to the exam',
  examDetail_allow_camera: 'Please click "Allow" to enable the proctoring camera',
  examDetail_invigilating: 'Proctoring',
  allow_camera: 'Click to access camera',
  examDetail_submit_failed: 'Network error. Failed to hand in',
  examDetail_overtime: 'The exam is invalid as exam time has expired for more than 10 minutes',
  examDetail_next_step: 'You cannot modify your answer to this question after jumping to the next question. Move to the next question?' ,
  examDetail_not_prompt_again: "Don't prompt again",
  examDetail_determine: 'OK(15s)',
  examDetail_time_limit: 'The time limit for this question is {nowLimitTime} seconds',
  examDetail_unchangeable: 'This question has been submitted and cannot be modified',
  examDetail_submit_exam_page: 'Submit',
  examDetail_previous: 'Previous Question',
  examDetail_next: 'Next question',
  examDetail_no_mistake: 'No incorrect questions for now',
  examDetail_limitTip: 'Upload up to {limit, plural, =0 {no files.} =1 {one file.} other {# files.}}',
  examDetail_not_allow_special_symbols: 'For attachment of attachment questions, file names may not contain special symbols',
  examDetail_limit_size: 'Single file cannot exceed {size}M, please reselect',
  examDetail_not_allow_empty: 'Empty file cannot be uploaded, please reselect',
  examDetail_upload_attachment_tip: 'Please upload attachments to complete your answer (up to three attachments can be uploaded, with each not exceeding {size}M)',
  examDetail_clean_up: 'Clear',
  examDetail_revoke: 'Revoke',
  examDetail_lineTips: 'Tip: please connect from left to right, and more than one choice chan be connected to the left',
  examDetail_clearTip: 'Clear the matching line?',
  examDetail_referAnswer: 'Reference answer',
  examDetail_enter_answer: "Please enter your answer at here",
  examDetail_uploadImageTip: 'Up to 9 images in JPG/PNG/JPEG format can be uploaded, with each not exceeding 5M.' ,
  examDetail_uploadImage: 'Upload an image',
  examDetail_prompt_tip: "View tips",
  examDetail_download_exam: 'Download attached questions',
  examDetail_tip_info: 'Note:',
  examDetail_not_supported_audio: 'Your browser cannot play audio files',
  examDetail_try_later_audio: 'Audio conversion has not yet complete, please try later!' ,
  examDetail_voice_loading: 'Audio loading, please try later!' ,
  examDetail_voice_reading: 'Audio reading',
  examDetail_history_results: 'Historical results',
  examDetail_open_time: 'Open time:',
  examDetail_format_time: 'YYYY-MM-DD HH: mm',
  examDetail_no_limit_time: 'Unlimited time',
  examDetail_exam_num: 'Exam times:',
  examDetail_remainTimes: 'You have {remianingNum} chances to take the exam',
  examDetail_no_limit_num: 'Unlimited exam times',
  examDetail_exam_careful: 'Notes:',
  examDetail_attentionItem: 'After the exam starts, please do not close your browser or jump out of the window, otherwise the system will decide that the exam is over.' ,
  examDetail_invigilation_mode: 'Proctoring mode:',
  examDetail_invigilateItem: 'authentication is required to take the exam',
  examDetail_exam_marking: 'Marking',
  examDetail_scoreText: "Exam {isPassed} passed with the highest score {highestScore}",
  examDetail_already: "Yet",
  examDetail_not_yet: "Not yet",
  examDetail_highestScore: 'Recorded highest score: {highestScore}',
  examDetail_testNumTxt: 'NO. of Questions',
  examDetail_exam_duration: 'Duration',
  examDetail_minute: 'minute(s)',
  examDetail_unlimited: 'Unlimited',
  examDetail_exam_start: 'Start exam',
  examDetail_exam_no_start: 'Exam has not yet started',
  examDetail_exam_end: 'The exam is over',
  examDetail_exam_complete: 'Exam finished',
  examDetail_exam_registration: 'Sign up for exam',
  examDetail_exam_again: 'Try Again',
  examDetail_under_review: 'Pending approval',
  examDetail_info_submited: 'Registration is pending approval',
  examDetail_go_from_app: 'Unavailable. Please enter from App',
  examDetail_forbidden_enter: 'The upper limit for screenshots has been reached. You are not allowed to re-enter the exam. Please contact the administrator to lift the ban',
  examDetail_face_recognition: "Please open face recognition",
  examDetail_face_recognition_tip: "The exam requires examiees to open the face recognition proctoring. You have not opened the face recognition function, please open it first",
  examDetail_photograph: 'Take photo',
  examDetail_remake: 'Retake',
  examDetail_uploading: 'Uploading',
  examDetail_upload: 'Upload',
  examDetail_certification_passed: 'Authentication passed',
  examDetail_info_enter_success: 'Information entered successfully',
  examDetail_take_picture: 'Please face the camera and click to take a picture',
  examDetail_imgUpload: 'Shooting is done, please click to upload',
  examDetail_being_uploaded_review: 'Photo is being uploaded for review...' ,
  examDetail_time_over: 'There are {questionNum} questions in the exam. Times up. Hand in?',
  examDetail_continue_submit: 'Continue to hand in ({time})',
  examDetail_remaining_time: 'Exam time left:',
  examDetail_exam_total: 'There are {total, plural, =0 {no questions} =1 {one question} other {# questions}} in this exam',
  examDetail_not_answer: 'Left:',
  examDetail_answered: 'Answered:',
  examDetail_hasNoAnswer: 'There {questionAnswers, plural, =0 {are no questions} =1 {is one question} other {are # questions}} in the exam. You have answered {yesArr, plural, =0 {no questions} =1 {one question} other {# questions}}, and there {noArr, plural, =0 {are no questions} =1 {is one question} other {are # questions}} left. Submit?' ,
  examDetail_all_complete: 'There {questionAnswers, plural, =0 {are no questions} =1 {is one question} other {are # questions}} in the exam. You have answered all questions. Hand in?' ,
  examDetail_go_back_continue: 'Return to continue to answer',
  examDetail_reference_answer_colon: 'Reference answer:'
}
